import type { z } from 'zod';
import { nonnullable } from '@/lib/zod-helper';
import { dailyCareShiftStatusDtoSchema } from '~/generated/inis/zod-schema';

export const DEFAULT_DEBOUNCE_DELAY = 500 as const;

export const DEFAULT_SEARCH_LIMIT = 50 as const;

export const DEFAULT_POLLING_INTERVAL = 30_000 as const;

export const SHIFT_TYPES = ['night', 'day', 'evening'] as const;
export type ShiftType = (typeof SHIFT_TYPES)[number];

export const shiftPeriodSchema = nonnullable(
  dailyCareShiftStatusDtoSchema.shape.shiftPeriod,
);
export type ShiftPeriod = z.infer<typeof shiftPeriodSchema>;
export const SHIFT_PERIODS = shiftPeriodSchema.options;

export const SHIFT_PERIOD_BY_TYPE = {
  night: 'NIGHT',
  day: 'DAY',
  evening: 'EVENING',
} as const satisfies Record<ShiftType, ShiftPeriod>;

export const SHIFT_START_HOUR = {
  night: 0,
  day: 8,
  evening: 16,
} as const satisfies Record<ShiftType, number>;
